import Button from '@mui/material/Button';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useState } from 'react';
import { HiPlus } from 'react-icons/hi';
import { IAddNewGroupButton } from '../../../interfaces/components/modal.interface';

const DynamicModifyGroupModal = dynamic(
  () => import('../../modal/training-module/ModifyGroupModal')
);

const AddNewGroupButton: React.FC<IAddNewGroupButton> = ({ queryKey }) => {
  const [openModifyFolder, setOpenModifyFolder] = useState<boolean>(false);

  return (
    <>
      {/* desktop add new button */}
      <div className="hidden lg:block">
        <Button
          onClick={() => {
            setOpenModifyFolder(true);
          }}
          className="!hover:bg-primary_lighter group !flex !gap-2 !bg-primary_lighter !px-5 !py-2 !text-sm !normal-case !text-white"
        >
          <div className="rounded-full bg-primary_supa_lighter p-[2px]">
            <HiPlus color="#ffffff" size={20} />
          </div>
          Nhóm mới
        </Button>
      </div>
      {/* mobile add new button */}
      <button
        onClick={() => {
          setOpenModifyFolder(true);
        }}
        id="add-new-button"
        className="cursor-pointer rounded-full bg-primary_lighter p-3 lg:hidden"
      >
        <div className="h-[19px] w-[19px]">
          <Image src="/icons/plus.svg" width={18} height={18} />
        </div>
      </button>

      {openModifyFolder && (
        <DynamicModifyGroupModal
          queryKey={queryKey || ''}
          open={openModifyFolder}
          setOpen={() => setOpenModifyFolder(false)}
        />
      )}
    </>
  );
};
export default AddNewGroupButton;
